import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_FORMTEMPLATEFILETYPE_LOAD,
    ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID,

    ACTION_FORMTEMPLATEFILETYPE_SAVE,

    ACTION_FORMTEMPLATEFILETYPE_CREATE,

    ACTION_FORMTEMPLATEFILETYPE_VALIDATE,

    IFormTemplateFileTypeLoadAction,
    IFormTemplateFileTypeLoadByIdAction,
    IFormTemplateFileTypeLoadFailureAction,
    IFormTemplateFileTypeLoadSuccessAction,

    IFormTemplateFileTypeSaveAction,
    IFormTemplateFileTypeSaveSuccessAction,
    IFormTemplateFileTypeSaveFailureAction,

    IFormTemplateFileTypeCreateAction,
    IFormTemplateFileTypeCreateSuccessAction,
    IFormTemplateFileTypeCreateFailureAction,

    IFormTemplateFileTypeValidateAction,
    IFormTemplateFileTypeValidateSuccessAction,
    IFormTemplateFileTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/formTemplateFileTypes";
import { formTemplateFileTypeApi } from "../services/formTemplateFileType";

export const
    getFormTemplateFileTypesEpic = (action$): Observable<IFormTemplateFileTypeLoadSuccessAction | IFormTemplateFileTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_LOAD)
            .mergeMap((_action: IFormTemplateFileTypeLoadAction) => {
                return formTemplateFileTypeApi
                    .getFormTemplateFileTypes()
                    .map(response =>
                        LoadSuccess(response.formTemplateFileTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getFormTemplateFileTypeByIdEpic = (action$): Observable<IFormTemplateFileTypeLoadSuccessAction | IFormTemplateFileTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID)
            .mergeMap((action: IFormTemplateFileTypeLoadByIdAction) => {
                return formTemplateFileTypeApi
                    .getFormTemplateFileTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.formTemplateFileType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setFormTemplateFileTypeEpic = (action$): Observable<IFormTemplateFileTypeSaveSuccessAction | IFormTemplateFileTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_SAVE)
            .mergeMap((action: IFormTemplateFileTypeSaveAction) => {
                return formTemplateFileTypeApi
                    .setFormTemplateFileType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.formTemplateFileType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createFormTemplateFileTypeEpic = (action$): Observable<IFormTemplateFileTypeCreateSuccessAction | IFormTemplateFileTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_CREATE)
            .mergeMap((_action: IFormTemplateFileTypeCreateAction) => {
                return formTemplateFileTypeApi
                    .createFormTemplateFileType()
                    .map(response =>
                        CreateSuccess(
                            response.formTemplateFileType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateFormTemplateFileTypeEpic = (action$): Observable<IFormTemplateFileTypeValidateSuccessAction | IFormTemplateFileTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_VALIDATE)
            .mergeMap((action: IFormTemplateFileTypeValidateAction) => {
                return formTemplateFileTypeApi
                    .validateFormTemplateFileType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.formTemplateFileType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }